export default function AuthorFold({
    author
}) {

  return (
    <div className="container box background-white rounded-corner">
        <div className="author-top">
            { author.acf.image?.url && (
                <img src={author.acf.image?.url} />
            )}

            <div className="author-info">
                <h2>{ author.title?.rendered }</h2>
                <span>{ author.acf?.function }</span>
            </div>
        </div>
        
        <div className="author-description">
            <div 
                dangerouslySetInnerHTML={{ __html: author.acf?.description }} 
                className="test" 
            />
        </div>

        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": author.title?.rendered,
            "jobTitle": author.acf?.function
          })}}
        />

      <style jsx>{`
        .author-top {
            display: flex;
            align-items: center;
            margin-bottom: 25px;
        }

        .author-top h2 {
            margin-bottom: 0;
        }

        .author-top img {
            background-color: #f4f4f4;
            border-radius: 50%;
            width: 100px;
            margin-right: 40px;
            margin-bottom: 0;
        }

        .author-info h2 {
            display: block;
        }

        .author-info span {
            color: #7a82fc;
        }

        .author-description > p {
            margin-bottom: 0;
            font-size: 15px;
            background-color: green;
        }

        .author-description {
            font-size: 15px;
        }

        .box {
            padding: 20px 20px 5px 20px;
        }
      `}</style>
    </div>
  )
}
